require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/core-js/library/fn/symbol/iterator.js
// module id = 190
// module chunks = 0